import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import HeroCarousel from '../components/HeroCarousel';
import MastitisTimeline from '../components/MastitisTimeline';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <Layout isHomePage={true}>
      <Helmet>
        <title>Adept Knowledge Technologies - Transforming Real-World Problems into Smart Solutions</title>
        <meta name="description" content="Adept Knowledge Technologies, founded in 2020, transforms real-world problems into smart solutions using AI, data science, and domain-driven innovation. Specialising in livestock health, dairy sustainability, and smart technology." />
        <link rel="canonical" href="https://www.ak-tech.in/" />
        <meta property="og:title" content="Adept Knowledge Technologies - Smart Tech Solutions" />
        <meta property="og:description" content="Transforming real-world problems into smart solutions using AI, data science, and domain-driven innovation." />
        <meta property="og:url" content="https://www.ak-tech.in/" />
        <meta name="twitter:title" content="Adept Knowledge Technologies - Smart Tech Solutions" />
        <meta name="twitter:description" content="Transforming real-world problems into smart solutions using AI, data science, and domain-driven innovation." />
      </Helmet>
      <HeroCarousel />
      <MastitisTimeline />
      <Footer />
    </Layout>
  );
};

export default HomePage;